import ServiceRequest from "./ServiceRequest";
import ServiceResponse from "./ServiceResponse";
import { RequestOptions } from "./ServiceRequest";

class ServiceTransaction<T = any> {
  request: ServiceRequest
  response: ServiceResponse<T>;
  id: number;

  get status(): string {
    if (!this.response.failure && !this.response.success) return "Pending";
    if (!this.response.failure) return "Success";
    return "Failure";
  }

  constructor(id: number, url: string, method: string, options?: RequestOptions) {
    this.id = id;
    this.request = new ServiceRequest(url, method, options);
    this.response = ServiceResponse.Pending();
  }

  Succeeded(data: T): ServiceResponse<T> {
    this.response = ServiceResponse.Succeeded(data);
    this.emitUpdated(this);
    return this.response;
  }
  
  Failed(code: number, message: string): ServiceResponse<T> {
    this.response = ServiceResponse.Failed(code, message);
    this.emitUpdated(this);
    return this.response;
  }

    // Expose transactions for external access via custom event handler for new transactions
  private onUpdatedCallbacks: Array<(transaction: ServiceTransaction<any>) => void> = [];

  // This returns a function that can be called to unsubscribe from updates.
  // When does the returned function get called?
  // The returned function is not called automatically by onUpdated.
  // It is up to the code that calls onUpdated to call the returned function when it wants to "unsubscribe" or stop listening for updates.
  public onUpdated(callback: (transaction: ServiceTransaction<any>) => void): () => void {
    this.onUpdatedCallbacks.push(callback);
    return () => {
      this.offUpdated(callback);
    };
  }

  private offUpdated(callback: (transaction: ServiceTransaction<any>) => void): void {
    this.onUpdatedCallbacks = this.onUpdatedCallbacks.filter(cb => cb !== callback);
  }

  private emitUpdated(transaction: ServiceTransaction<any>): void {
    this.onUpdatedCallbacks.forEach(cb => cb(transaction));
  }

}

export default ServiceTransaction;